import { Link } from 'react-router-dom';
import { Modal, Badge, label } from './ui.jsx';
import { t, getLang } from '../i18n/index.jsx';

const TYPE_LABELS = { task: 'Task', contract: 'Contract expiry', sal: 'Payment milestone' };

export default function EventDetailModal({ event, onClose }) {
  if (!event) return null;
  const typeLabel = t(TYPE_LABELS[event.EventType] || 'Event');
  const dateStr = event.StartTime
    ? new Date(event.StartTime).toLocaleDateString(getLang() === 'it' ? 'it-IT' : 'en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
    : '—';

  return (
    <Modal
      title={t('{type} details', { type: typeLabel })}
      onClose={onClose}
      footer={
        <div className="modal-actions">
          <div className="spacer" />
          {event.Link && (
            <Link to={event.Link} className="btn primary sm" onClick={onClose}>{t('Go to details')}</Link>
          )}
          <button type="button" className="btn ghost sm" onClick={onClose}>{t('Close')}</button>
        </div>
      }
    >
      <dl className="sf-event-detail">
        <div>
          <dt>{t('Title')}</dt>
          <dd style={{ fontWeight: 600 }}>{event.Subject}</dd>
        </div>
        {event.ProjectName && <div><dt>{t('Project')}</dt><dd>{event.ProjectName}</dd></div>}
        {event.ClientName && <div><dt>{t('Client')}</dt><dd>{event.ClientName}</dd></div>}
        {event.FundName && <div><dt>{t('Fund / body')}</dt><dd>{event.FundName}</dd></div>}
        {event.PlannedAmount != null && (
          <div>
            <dt>{t('Planned amount')}</dt>
            <dd style={{ fontWeight: 600, color: 'var(--primary)' }}>€{Number(event.PlannedAmount).toLocaleString()}</dd>
          </div>
        )}
        {event.AssigneeName && <div><dt>{t('Assignee')}</dt><dd>{event.AssigneeName}</dd></div>}
        <div><dt>{t('Date')}</dt><dd>{dateStr}</dd></div>
        {event.Status && (
          <div>
            <dt>{t('Status')}</dt>
            <dd>
              <Badge tone={
                ['done', 'approved', 'paid'].includes(event.Status) ? 'green'
                  : ['in_progress', 'sent', 'active'].includes(event.Status) ? 'blue'
                    : ['blocked', 'expired'].includes(event.Status) ? 'red' : 'gray'
              }>{label(event.Status)}</Badge>
            </dd>
          </div>
        )}
      </dl>
    </Modal>
  );
}
